import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Loader, Text, Theme, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import { getMetrics } from '../../actions/master.js';
import { helpers } from "@simplybenefits/sb-utils";

class Metrics extends PureComponent {
    state = {
        loading: true,
        metrics: null
    };

    async componentDidMount() {
        const metrics = await this.props.dispatch(getMetrics());

        if (metrics) {
            this.setState({
                loading: false,
                metrics
            });
        }
    }

    render() {
        if (!this.state.metrics || this.state.loading) {
            return <Loader isContainer/>;
        }

        const { metrics } = this.state;
        const styles = {
            blockContainer: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start'
            },
            blockRow: {
                flex: 1,
                display: 'flex',
                flexDirection: 'row'
            },
            block: {
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
                background: '#FFF',
                width: '320px',
                height: '160px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                margin: '8px',
                position: 'relative'
            }
        };
        
        return (
            <ContainerControlSite>
                <Header
                    subHeader="Metrics"
                    selectedTitle="metrics"
                />

                <Content>
                    <div style={ styles.blockContainer }>
                        <Text
                            medium
                            bold
                            display="block"
                            align="left"
                            margin="10px 0 2px 10px"
                        >
                            Users & Accounts
                        </Text>

                        <div style={ styles.blockRow }>
                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.activeMembers }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    ACTIVE MEMBERS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.activeDependents }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    ACTIVE DEPENDENTS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.activeMembers + metrics.activeDependents }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    TOTAL ACTIVE USERS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.activeAccounts }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    ACTIVE ACCOUNTS
                                </Text>
                            </div>
                        </div>

                        <Text
                            medium
                            bold
                            display="block"
                            align="left"
                            margin="20px 0 2px 10px"
                        >
                            Claims This Month
                        </Text>

                        <div style={ styles.blockRow }>
                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.totalSubmittedClaims }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    CLAIMS SUBMITTED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.numberPaidClaims }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PAID CLAIMS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.totalDeclinedClaims }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    DECLINED CLAIMS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.brandGreen}
                                >
                                    ${ helpers.numberWithCommasDecimals(Number(metrics.totalClaimsAmountPaid)) }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    AMOUNT PAID
                                </Text>
                            </div>
                        </div>

                        <Text
                            large
                            bold
                            display="block"
                            align="left"
                            margin="20px 0 2px 10px"
                        >
                            Auto Adjudication Stats (Excluding EClaims)
                        </Text>

                        <Text
                            medium
                            bold
                            display="block"
                            align="left"
                            margin="20px 0 2px 10px"
                        >
                            Paramedicals (Past 7 days)
                        </Text>

                        <div style={ styles.blockRow }>
                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.paramedicals.totalClaimsSubmitted }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    CLAIMS SUBMITTED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.paramedicals.totalClaimsAdjudicated }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    ADJUDICATED CLAIMS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.paramedicals.agentAdjudicatedPercentage }%
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PERCENT AGENT ADJUDICATED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.brandGreen}
                                >
                                    { metrics.autoAdjudicationStats.paramedicals.autoAdjudicatedPercentage }%
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PERCENT AUTO ADJUDICATED
                                </Text>
                            </div>
                        </div>

                        <Text
                            medium
                            bold
                            display="block"
                            align="left"
                            margin="20px 0 2px 10px"
                        >
                            Vision (Past 7 days)
                        </Text>

                        <div style={ styles.blockRow }>
                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.vision.totalClaimsSubmitted }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    CLAIMS SUBMITTED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.vision.totalClaimsAdjudicated }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    ADJUDICATED CLAIMS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.vision.agentAdjudicatedPercentage }%
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PERCENT AGENT ADJUDICATED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.brandGreen}
                                >
                                    { metrics.autoAdjudicationStats.vision.autoAdjudicatedPercentage }%
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PERCENT AUTO ADJUDICATED
                                </Text>
                            </div>
                        </div>

                        <Text
                            medium
                            bold
                            display="block"
                            align="left"
                            margin="20px 0 2px 10px"
                        >
                            Spending Account (Past 7 days)
                        </Text>

                        <div style={ styles.blockRow }>
                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.spendingAccounts.totalClaimsSubmitted }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    CLAIMS SUBMITTED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.spendingAccounts.totalClaimsAdjudicated }
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    ADJUDICATED CLAIMS
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.skyBlue}
                                >
                                    { metrics.autoAdjudicationStats.spendingAccounts.agentAdjudicatedPercentage }%
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PERCENT AGENT ADJUDICATED
                                </Text>
                            </div>

                            <div style={ styles.block }>
                                <Text
                                    largest
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.brandGreen}
                                >
                                    { metrics.autoAdjudicationStats.spendingAccounts.autoAdjudicatedPercentage }%
                                </Text>

                                <Text
                                    small
                                    uppercase
                                    bold
                                    display="block"
                                    align="left"
                                    margin="0 0 2px 0"
                                    color={Theme.colors.darkBlue}
                                >
                                    PERCENT AUTO ADJUDICATED
                                </Text>
                            </div>
                        </div>
                    </div>
                </Content>
                <span id="notifications" />
            </ContainerControlSite>
        );
    }
}

export default (connect()(Metrics));